const MenuSeparator = () => (
  <div className="flex h-[1rem] items-center" aria-hidden>
    <span className="h-px w-full bg-stroke" />
  </div>
);

export { MenuSeparator };
